(($) => {

	const $header = $('.header');

	// Skip content link looks for h1 tag before going to default anchor element
	const skipToContent = event => {
		const $heading = $('h1:not(.header-title):eq(0)');

		if( $heading.size() ) {
			event.preventDefault();

			$heading.attr( 'tabindex', '0' );

			setTimeout( () => {
				$heading.focus();
			}, 100 );
		}
	};

	$('[href="#mainContentAnchor"]').click( skipToContent );
	$('[href="#mainContentAnchor"]').keypress( event => event.keyCode === 13 ? skipToContent( event ) : null );

	// Keep submenus open when their children are focused
	const expandedClass = 'expanded';

	$header.find('.sub-menu li').focusin( event =>
		$( event.target ).parents('.menu-item').addClass( expandedClass )
	);
	$header.find('.sub-menu li').focusout( event =>
		$( event.target ).parents('.menu-item').removeClass( expandedClass )
	);
	$header.find('.menu-item:not(.header-searchButton)').keydown( event =>
		event.keyCode == 13 ? $( event.target ).children('a')[0].click() : null
	);

	// Header search form
	const $searchButton = $header.find('.header-searchButton, .header-icon-search');
	const $searchInput = $header.find('.header-search-input');

	const configureSearchButtonAriaLabels = () => {
		const $desktopSearchButton = $('.header-searchButton');
		const $mobileSearchButton = $('.header-icon-search');

		if( Foundation.MediaQuery.atLeast('xlarge') ) {
			$mobileSearchButton.attr( 'aria-hidden', 'true' );
			$desktopSearchButton.attr( 'aria-hidden', '' );
		} else {
			$mobileSearchButton.attr( 'aria-hidden', '' );
			$desktopSearchButton.attr( 'aria-hidden', 'true' );
		}
	};

	$( document ).ready( configureSearchButtonAriaLabels );
	$( window ).resize( configureSearchButtonAriaLabels );

	const activateSearch = () => {
		$header.removeClass('mobileMenuActive').toggleClass('searchActive');

		if( $header.hasClass('searchActive') ) {
			$searchInput
				.attr( 'aria-hidden', '' )
				.attr( 'tabindex', 0 )
				.focus();
		} else {
			$searchInput
				.attr( 'aria-hidden', 'true' )
				.attr( 'tabindex', -1 );
		}
	};

	$searchButton.click( activateSearch );
	$searchButton.keydown( event => event.keyCode == 13 ? activateSearch() : null );

	// Mobile menu
	const $mobileMenuButton = $header.find('.header-icon-menu');
	const $parentMenuItems = $header.find('.header-mainMenu > li.menu-item-has-children > a');

	$mobileMenuButton.on( 'click ', event => {
		if( event.type === 'click' || event.keyCode === 13 ) {
			$header.removeClass('searchActive').toggleClass('mobileMenuActive');
		}
	});

	// Close the mobile menu if the user clicks on an irrelevant element
	$( document ).on( 'click', event => {
		try {
			const $relevantElements = $header.find('.header-menus').add( $mobileMenuButton ).add( $searchButton );
			const $target = $( event.target );
			const isRelevantElement = Boolean( $relevantElements.is( $target ) || $relevantElements.has( $target ).length );

			// If not relevant to megamenus, then close them all
			if( ! isRelevantElement ) $header.removeClass('searchActive mobileMenuActive');
		} catch( error ) {
			console.log( error, event );
		}
	});

	$parentMenuItems.click( event => {
		if( ! Foundation.MediaQuery.atLeast('xlarge') ) {
			event.preventDefault();

			$( event.currentTarget ).parents('.menu-item').toggleClass('open');
		}
	});

	const configureMobileMenuAriaLabels = () => {
		$parentMenuItems.each( ( i, el ) => {
			const $parentMenuItem = $( el );

			if( Foundation.MediaQuery.atLeast('xlarge') ) {
				$parentMenuItem
					.attr( 'aria-hidden', '' )
					.parent('li')
					.attr( 'aria-label', '' );
			} else {
				$parentMenuItem
					.attr( 'aria-hidden', 'true' )
					.parent('li')
					.attr( 'aria-label', $parentMenuItem.text() );
			}
		});
	};

	$( document ).ready( configureMobileMenuAriaLabels );
	$( window ).resize( configureMobileMenuAriaLabels );

})(jQuery);



// WEBPACK FOOTER //
// ../benetech/js/components/site-header.js